<template>
        <div class="view">
          <v-breadcrumbs>
            <v-breadcrumbs-item :exact="true" :to="{ name: 'home', params: {} }"
              >Home</v-breadcrumbs-item
            >
            <v-breadcrumbs-divider>/</v-breadcrumbs-divider>
            <v-breadcrumbs-item :exact="true" :to="{ name: 'ruleCertification', params: {} }">
            Rule Certification
            </v-breadcrumbs-item>
            <v-breadcrumbs-divider>/</v-breadcrumbs-divider>
            <v-breadcrumbs-item :to="{ name: 'ruleCertificationView', params: {} }">
              View Rule Certification
            </v-breadcrumbs-item>
          </v-breadcrumbs>

          <v-card v-if="loaded">
            <v-card-title>
              View Rule Certification
            </v-card-title>
            <v-card-text>
              <v-simple-table>
                <template v-slot:default>
                  <tbody>
                    
          <tr v-if="ruleCertification.type">
            <td max-width="35%" class="text-subtitle-1">Type:</td>
            <td>{{ ruleCertification.type }}</td>
          </tr>
          
          <tr v-if="ruleCertification.validationPeriod">
            <td max-width="35%" class="text-subtitle-1">Valid Period:</td>
            <td>{{ ruleCertification.validationPeriod }}</td>
          </tr>
          
          <tr v-if="ruleCertification.validationPeriodUnit">
            <td max-width="35%" class="text-subtitle-1">Validation Period:</td>
            <td>{{ ruleCertification.validationPeriodUnit }}</td>
          </tr>
          
          <tr v-if="ruleCertification.requirement">
            <td max-width="35%" class="text-subtitle-1">Requirement:</td>
            <td>
              {{ getRelationText(ruleCertification.requirement, "requirement", "name") }}
            </td>
          </tr>
          
                  </tbody>
                </template>
              </v-simple-table>
            </v-card-text>
          </v-card>

          <div class="d-flex justify-space-between ma-5">
            <v-btn @click="goBack">Back</v-btn>
            <v-btn @click="edit(id)" color="primary">Edit</v-btn>
            <span></span>
          </div>
      </div>
    </template>

    <script>
    import { getRuleCertification } from "@/services/ruleCertification";
    
              import { getAllRequirements } from "@/services/requirement";
            

    export default {
      data() {
        return {
            id: '',
            ruleCertification: {},
            loaded: false,
            relations: {}
        }
      },
      methods : {
        goBack() {
          this.$router.go(-1);
        },
        edit(id) {
          this.$router.push({ name: "ruleCertificationEdit", params: { id: id }});
        },
        setInstance() {
          this.setDependencies().then( () => {
            getRuleCertification(this.id)
            .then((response) => {
              this.ruleCertification = response.data;
              this.loaded = true;
            })
            .catch( () => {
              this.addErrorMessage("Error loading ruleCertification");
              this.loaded = true;
            });
          })
        },
        async setDependencies() {
          
            const params_requirement = {
              page: 0,
              size: 100
            };
            await getAllRequirements(params_requirement)
              .then(response => {
                this.relations.requirement = response.data.content;
                return this.relations.requirement;
              });
            
        },
        getRelationText(id, relationProperty, relationAttribute) {
          const relationList = this.relations[relationProperty];
          if (relationList) {
            const relationObj = relationList.find(r => r.id == id);
            return relationObj[relationAttribute];
          } else {
            return "";
          }
        }
      },
      created() {
        this.id = this.$route.params.id;
        this.setInstance();
        this.$emit("showParent", false);
      }
    }
    </script>
    